import React from 'react';
import {Link} from 'react-router-dom';
import AurProgressChart, {
  ProgressChartDataSetType,
} from '../../../common/aur-progress-chart/AurProgressChart';
import {Typography} from '@mui/material';

const ProgressBarChart: React.FC = () => {
  const dataSet: ProgressChartDataSetType[] = [
    {
      total: 100,
      progress: 40,
      filledColor: '#6E87FF',
      key: 'email',
      tooltip: {
        filled: <Typography>Filled Bar 40</Typography>,
        unFilled: 'No filled ',
      },
    },
    {
      total: 130,
      progress: 40,
      filledColor: '#00D0DB',
      key: 'other',
      tooltip: {
        filled: <Typography>Filled Bar 40</Typography>,
        unFilled: 'Remain to progress count 250',
      },
    },
    {
      total: 200,
      progress: 50,
      filledColor: '#9F75DF',
      key: 'file',
      tooltip: {
        filled: <Typography>Progress count 50</Typography>,
        unFilled: 'Remain to progress count 250',
      },
    },
  ];

  return (
    <>
      <div style={{marginBottom: '64px'}}>
        <h1>ProgressBar Chart</h1>
        <div>
          Component to display various type of progress report in chart.
        </div>
        <Link to="/demo">Return</Link>
        <hr />
        <div>Default Big Version</div>
        <div style={{padding: '32px'}}>
          <AurProgressChart dataSet={dataSet} />
        </div>

        <hr />
        <div>Configurable Version</div>
        <div style={{padding: '32px'}}>
          <AurProgressChart
            dataSet={[
              ...dataSet,
              {total: 150, progress: 50, filledColor: 'red', key: 'other file'},
            ]}
            layout={{
              barWidth: 4,
              barHeight: 20,
              spaceBetweenBar: 1,
            }}
          />
        </div>
      </div>
    </>
  );
};

export default ProgressBarChart;
